export default {
    meta: {
        title: '亚瑟士-创建机会点'
    }
};
